<template>
    <div class="container-fluid">
        <b-grid
            :tableOptions="scheduledNoticeStore.tableOptions"
            :items="scheduledNoticeStore.scheduledNotices"
            :columns="scheduledNoticeStore.columns"
            :show-filter="false"
            :show-paging="false"
            @optionChange="scheduledNoticeStore.getScheduledNotices()">
            <template #cell.actions="{item}">
                <div class="hstack gap-2">
                    <button
                        class="btn btn-link ms-0 ps-0 text-start"
                        @click.prevent="handleEditClick(item)"
                        v-if="
                            !(item.schedule.type == NotificationScheduleType.OneTime && item.first_run != '0001-01-01')
                        ">
                        Edit
                    </button>
                    <button
                        class="btn btn-link ms-0 ps-0 text-start"
                        @click.prevent="handleCloneClick(item)">
                        Clone
                    </button>
                </div>
            </template>
        </b-grid>
    </div>
</template>
<script setup lang="ts">

import {computed, ref, onMounted, watch} from "vue";
import BGrid from "../BGrid/BGrid.vue";
import {useScheduledNoticeStore} from "@/stores/scheduledNoticeStore";
import {ScheduledItem, NotificationScheduleType} from "./types";
import {clone} from "@/utils";

const scheduledNoticeStore = useScheduledNoticeStore();

const props = defineProps<{}>();

const emit = defineEmits<{
    (e: "edit-click", item: ScheduledItem): void;
}>();

onMounted(() => {
    scheduledNoticeStore.getScheduledNotices();
});

function handleEditClick(item: ScheduledItem) {
    emit("edit-click", clone(item));
}

function handleCloneClick(item: ScheduledItem) {
    item.id = -1;
    let currentDate = new Date();

    item.schedule.year = currentDate.getFullYear();
    item.schedule.month = currentDate.getMonth() + 1;
    item.schedule.weekday = currentDate.getDay();
    item.schedule.date = currentDate.getDate();
    item.schedule.hour = 0;
    item.schedule.minute = 0;

    emit("edit-click", item);
}
</script>
